'use strict';
function o(t) {
  return t ? Intl.DateTimeFormat("en-AU", {
    hour: "numeric",
    minute: "numeric",
    hour12: !0
  }).format(new Date(t)).toUpperCase() : null;
}
function m(t) {
  return t ? Intl.DateTimeFormat("en-AU", {
    day: "numeric",
    month: "short",
    year: "numeric"
  }).format(new Date(t)) : null;
}
function a(t) {
  return t ? Intl.DateTimeFormat("en-AU", {
    day: "numeric",
    month: "short"
  }).format(new Date(t)) : null;
}
function u(t) {
  return t ? Intl.DateTimeFormat("en-AU", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: !0
  }).format(new Date(t)) : null;
}
const i = (t, r) => {
  const n = t.toString().padStart(2, "0"), e = r.toString().slice(-2);
  return `${n} / ${e}`;
}, c = (t) => {
  const [r, n] = t.split("/").map((e) => e.trim());
  return [parseInt(r), parseInt(`20${n}`)];
};
export {
  m as formatDate,
  u as formatDateTime,
  i as formatExpiryDate,
  a as formatShortDate,
  o as formatTime,
  c as parseExpiryDate
};
